import React from "react";
import { Modal } from "antd";
import { ModalProps } from "antd/es/modal";
import styles from "./index.module.scss";

interface PhotoDetailProps extends ModalProps {
    photo: string;
}

export default function PhotoDetail({ photo, ...props }: PhotoDetailProps) {
    return (
        <Modal
            className={styles.root}
            width="auto"
            footer={false}
            centered
            {...props}
            closable={false}>
            <img className={styles.photo} src={photo} />
        </Modal>
    );
}
